import { useTranslation } from 'react-i18next'

import { usePageBrowserTabTitle } from '../../../hooks'
import { NotificationProvider } from '../../Notification'
import { Auth } from '../Auth'

import { RegistrationForm } from './RegistrationForm'

function Registration() {
  const { t } = useTranslation()

  usePageBrowserTabTitle({
    pageTitle: t('BrowserTab.RegistrationPageTitleKey'),
  })

  return (
    <Auth>
      {/* TODO Investigate why NotificationProvider doesn't work if put it in Auth */}
      {/* Suppose something with imports */}
      <NotificationProvider>
        <RegistrationForm />
      </NotificationProvider>
    </Auth>
  )
}

export default Registration
